import { Component, inject } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { TareaService } from '../../services/tarea.service';
import { ScnackbarData, ToastService, SnackbarStyles } from '../toast.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { UtilService } from '../../services/util.service';

@Component({
    selector: 'app-dlg-cerrar-tareas-elaboracion',
    imports: [
        MatDialogModule,
        MatButtonModule,
        ReactiveFormsModule, FormsModule,
        MatInputModule,
        MatProgressSpinnerModule
    ],
    templateUrl: './dlg-cerrar-tareas-elaboracion.component.html',
    styleUrl: './dlg-cerrar-tareas-elaboracion.component.scss'
})
export class DlgCerrarTareasElaboracionComponent {
  readonly data = inject<number>(MAT_DIALOG_DATA);
  utilService = inject(UtilService)
  fetchingCloseOpenDocumentNewTasks = false

  constructor(
    public dialogRef: MatDialogRef<DlgCerrarTareasElaboracionComponent>,
    private tareaService: TareaService,
    private toast: ToastService,
  ) { }

  cerrarTareasDocumentoElaboracion() {
    this.fetchingCloseOpenDocumentNewTasks = true
    this.tareaService.cerrarNuevasTareasDocumentoEnElaboracion(this.data.toString()).subscribe({
      next: (_) => {
        const snackbarData: ScnackbarData = {
          message: "Nuevas tareas cerradas",
          style: SnackbarStyles.Success,
          iconName: "check_circle"
        }
        this.toast.show(snackbarData)
        this.utilService.callTasks();
        this.fetchingCloseOpenDocumentNewTasks = false
        this.dialogRef.close(true)
      },
      error: (_) => {
        const snackbarData: ScnackbarData = {
          message: "Error cerrando nuevas tareas",
          style: SnackbarStyles.Error,
          iconName: "error"
        }
        this.toast.show(snackbarData)
        this.fetchingCloseOpenDocumentNewTasks = false
        this.dialogRef.close(false)
      }
    })
  }


  close() {
    this.dialogRef.close(true);
  }
}
